export const DecodeMstCategory = {
  // ～予約関連～
  // 病名
  DIAGNOSIS: 'diagonosis',
  // 症状
  SYMPTOM: 'symptom',
  // 流行り病
  EPIDEMIC: 'epidemic',
  // 児童の容体が変化した場合
  EMERGENCY: 'emergency_action',
  // 栄養方法
  EATING_METHOD: 'eating_method',
  // 栄養方法＞授乳中詳細
  BREST_FEEDING_DETAIL: 'brest_feeding_detail',
  // 栄養方法＞離乳中詳細
  WEANING_DETAIL_OPTION: 'weaning_detail_options',
  // 食事状況
  EATING_ABILITY: 'eating_ability',
  // 行動
  ACTION: 'actions',
  // 排泄
  TOILET_ABILITY: 'toilet_ability',
  // 排泄
  REDUCTION: 'reduction_type',
  // 利用事由
  FORM_USE_REASON: 'form_use_reason',
  // 抽選予約キャンセル理由
  LOTTERY_CANCEL_REASON: 'lottery_cancel_reason',

  // 時間外料金の曜日設定
  SCHEDULED_DAY_TYPE: 'scheduled_day_type',
  // 時間外料金の時間
  TIME_UNIT_TYPE: 'time_unit_type',
  // 年齢別料金の時間
  AGE_REGION_BASED_FEE_TYPE: 'age_region_based_fee_type',
  // 年齢別料金の設定日
  AGE_REGION_BASED_FEE_DAY_TYPE: 'age_region_based_fee_day_type',
  /** 通常利用施設 施設種別 */
  NORMALLY_USED_FACILITIES_TYPE: 'normally_used_facilities_type',

  /** 当日入力（施設） 食事内容 */
  TODAY_CONDITION_INPUT_FACILITY_MEAL: 'today_condition_input_facility_meal',
  /** 当日入力 排便の状態 */
  DEFECATION_CONDITION: 'defecation_condition'
} as const
export type DecodeMstCategory = (typeof DecodeMstCategory)[keyof typeof DecodeMstCategory]
